export default __webpack_public_path__ + "static/media/397.c2dc5ac9.png";